// extracted by mini-css-extract-plugin
module.exports = {"design":"DesignsPage_design__21fYZ","design__note":"DesignsPage_design__note__2OfKA","cards":"DesignsPage_cards__1efxa"};